import Layout from '@/modules/layout/components/layout';
import ErrorPage from '@/modules/layout/components/ErrorPage.vue';
import NotFoundPage from '@/modules/layout/components/NotFoundPage.vue';
import MaintenancePage from './components/MaintenancePage.vue';

export default [
    // Generic full-screen error page, used for unexpected errors / 500 crashes.
    {
        name: 'error500',
        path: '/500',
        component: ErrorPage,
    },
    // In-app 404: rendered inside the application shell (menu/header)
    {
        path: '',
        component: Layout,
        meta: { auth: true },
        children: [
            {
                name: 'notFound',
                path: '/not-found',
                component: NotFoundPage,
                meta: { auth: true },
            },
        ],
    },
    {
        path: '/maintenance',
        name: 'maintenance',
        component: MaintenancePage,
        meta: { 
            public: true,
            requiresAuth: false 
        }
    }
];
